import React from 'react';
import MyRequestDetail from '../projects/myRequestDetail';

export default function RequestDetails() {
    return <MyRequestDetail />
}